export const screenshotImageSpotSelector = ({screenshotImageSpot}) => screenshotImageSpot